import { render } from "./StrapiModal.vue?vue&type=template&id=2e417809"
import script from "./StrapiModal.vue?vue&type=script&lang=js"
export * from "./StrapiModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__